const initState = {
  hull: {},
  front: {},
  corner: {},
  frontPatterns: {},
};

const defaultsReducer = (state = initState, action) => {
  switch (action.type) {
    case 'GET_PRODUCT_DEFAULTS_SUCCESS':
      return action.data;
    default:
      return state;
  }
};

export default defaultsReducer;
